export const environment = {
  BA_API_BASE_URL: 'https://api-billing-aggregation.si-interne-test.aws.soregies.fr',
  USER_SESSION_EXPIRY_DELAY_DAYS: 1,
  DOMAIN: 'https://billing-aggregation-test.auth.eu-central-1.amazoncognito.com',
  CLIENT_ID: '4v6na0p8i7isnf4k1s844mkhg6',
  REDIRECT_URI: 'https://test-billing-aggregation.soregies.fr/saml-callback/',
  COGNITO_IDENTITY_PROVIDER: 'ba-test-azure-provider',
  ENV: 'Test',
  WEBSOCKET_ENDPOINT: 'xt9r5gk5ki',
};
